// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.energy-content-wrapper {
  width: 100%;
  padding: 20px;
}

.item-row {
  display: flex;
  align-items: flex-start; 
  margin-bottom: 10px; 
  width: 116%;
}


.item-content {
  flex: 0 0 80%; 
  padding-right: 20px; 
}


.item-box {
  background-color: #e7f3ff;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
}


.question-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px; 
}

.question-text {
  flex: 1;
  margin-right: 10px; 
  font-weight: 600;
}

.details-box {
  background-color: #e7f3ff;
  padding: 10px;
  border-radius: 4px;
  color: #6C6E6B;
}

.input-dashed {
  border-bottom: 2px dashed #0056b3;
  width: 100px; 
  box-sizing: border-box;
  outline: none;
  font-size: 14px;
  color: #333;
  background: #e7f3ff;
  border-radius: 0;
}

.input-dashed:focus {
  border-bottom: 2px dashed #0056b3;
  border-width: 0;
}

.input-dashed:hover {
  background: #e7f3ff;
}


.select-dashed .ant-select-selector {
  border-bottom: 2px dashed #0056b3; 
  padding: 4px 0;
  width: 100px; 
  box-sizing: border-box;
  font-size: 14px;
  outline: none;
  background-color: transparent; 
  color: #333; 
}

.select-dashed .ant-select-selector:focus {
  border-bottom: 2px dashed #0056b3;
  border-width: 0;
}

.select-dashed .ant-select-selector:hover {
  background: #e7f3ff;
}

.button-container {
  flex: 0 0 20%; 
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px; 
  margin-top: 10px; 
}
.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
  border: none;
  background: none;
}

.emissions-saved {
  margin-top: 10px;
  font-size: 14px; 
  display: flex;
  align-items: center;
  width: 50%;
}
.emmissioons-Input {
  width: 120px;
}
.added-items {
  margin-top: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/components/reportingtab/energycontent.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,iCAAiC;EACjC,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".energy-content-wrapper {\n  width: 100%;\n  padding: 20px;\n}\n\n.item-row {\n  display: flex;\n  align-items: flex-start; \n  margin-bottom: 10px; \n  width: 116%;\n}\n\n\n.item-content {\n  flex: 0 0 80%; \n  padding-right: 20px; \n}\n\n\n.item-box {\n  background-color: #e7f3ff;\n  padding: 20px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n\n.question-box {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px; \n}\n\n.question-text {\n  flex: 1;\n  margin-right: 10px; \n  font-weight: 600;\n}\n\n.details-box {\n  background-color: #e7f3ff;\n  padding: 10px;\n  border-radius: 4px;\n  color: #6C6E6B;\n}\n\n.input-dashed {\n  border-bottom: 2px dashed #0056b3;\n  width: 100px; \n  box-sizing: border-box;\n  outline: none;\n  font-size: 14px;\n  color: #333;\n  background: #e7f3ff;\n  border-radius: 0;\n}\n\n.input-dashed:focus {\n  border-bottom: 2px dashed #0056b3;\n  border-width: 0;\n}\n\n.input-dashed:hover {\n  background: #e7f3ff;\n}\n\n\n.select-dashed .ant-select-selector {\n  border-bottom: 2px dashed #0056b3; \n  padding: 4px 0;\n  width: 100px; \n  box-sizing: border-box;\n  font-size: 14px;\n  outline: none;\n  background-color: transparent; \n  color: #333; \n}\n\n.select-dashed .ant-select-selector:focus {\n  border-bottom: 2px dashed #0056b3;\n  border-width: 0;\n}\n\n.select-dashed .ant-select-selector:hover {\n  background: #e7f3ff;\n}\n\n.button-container {\n  flex: 0 0 20%; \n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px; \n  margin-top: 10px; \n}\n.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {\n  border: none;\n  background: none;\n}\n\n.emissions-saved {\n  margin-top: 10px;\n  font-size: 14px; \n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n.emmissioons-Input {\n  width: 120px;\n}\n.added-items {\n  margin-top: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
